import YPAbstractEventObject from './YPAbstractEventObject';

export function sortEventsOnAnnouncedStartTime(event1, event2) {
  const datetime1 = event1.getStartTime();
  const datetime2 = event2.getStartTime();
  if (!datetime1 && !datetime2) return event1.compareEventNames(event2);
  if (datetime1 === null) return 1;
  if (datetime2 === null) return -1;
  if (datetime1.diff(datetime2) === 0) return event1.compareEventNames(event2);
  return datetime1.diff(datetime2);
}

export default class YPEventGroupObject extends YPAbstractEventObject {
  constructor(id, name, listOfEventObjects) {
    super({ id, name });
    this.events = listOfEventObjects;
    this.sortEvents();
    this.limitedEventsView = [...this.events];
    this.isLimited = false;
  }

  getGroupNameOrPlaceholder() {
    return this.name || `(${[i18n('unnamed event group')]})`;
  }

  getNumberOfAllChildren() {
    return this.events.reduce(
      (total, currentEvent) =>
        total + (currentEvent.isGroup() ? currentEvent.getNumberOfAllChildren() : 1),
      0
    );
  }

  getStartTime() {
    if (this.events.length === 0) return null;
    return this.events[0].getStartTime();
  }

  getEventAtIndex(index) {
    if (index >= this.limitedEventsView.length) return null;
    return this.limitedEventsView[index];
  }

  isGroup() {
    return true;
  }

  isFirstChildAGroup() {
    return this.events.length > 0 && this.events[0].isGroup();
  }

  isLastEventInGroup(index) {
    return index === this.limitedEventsView.length - 1;
  }

  equal(anEvent) {
    return anEvent.id === this.id;
  }

  addChild(eventObject) {
    this.events.push(eventObject);
    this.sortEvents();
    if (!this.isLimited) this.limitedEventsView = [...this.events];
  }

  hasChildWithPredicate(predicateFn) {
    return this.events.find(predicateFn);
  }

  doForEachEventOrGroup(groupCallback, eventCallback, limitedView = false) {
    const eventsCollection = limitedView ? this.limitedEventsView : this.events;
    return eventsCollection.map((eventOrGroup, index) => {
      if (eventOrGroup.isGroup()) {
        return groupCallback(eventOrGroup, index);
      }
      return eventCallback(eventOrGroup, index);
    });
  }

  setLimitedEventsView(limit) {
    if (this.getNumberOfAllChildren().length <= limit) return;
    let currentLimit = 0;
    const newLimitedEventsView = [];
    this.isLimited = true;
    this.events.every((eventOrGroup) => {
      if (currentLimit >= limit) return false;
      if (eventOrGroup.isGroup()) {
        eventOrGroup.setLimitedEventsView(limit - currentLimit);
        currentLimit += eventOrGroup.getNumberOfAllChildren();
        newLimitedEventsView.push(eventOrGroup);
      } else {
        currentLimit += 1;
        newLimitedEventsView.push(eventOrGroup);
      }
      return true;
    });
    this.limitedEventsView = newLimitedEventsView;
  }

  resetLimitedEventsView() {
    this.isLimited = false;
    this.limitedEventsView = this.events;
  }

  sortEvents() {
    this.events.sort(sortEventsOnAnnouncedStartTime);
  }
}
